"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EditModal = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _Modal = require("@insided/shared/uikit/Modal");

var _buttonControl = _interopRequireDefault(require("@insided/deprecated-preact-components/button-control"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EditModal = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EditModal, _Component);

  var _super = _createSuper(EditModal);

  function EditModal() {
    var _this$props$type;

    var _this;

    (0, _classCallCheck2.default)(this, EditModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      newName: (_this$props$type = _this.props.type) !== null && _this$props$type !== void 0 ? _this$props$type : ''
    });
    return _this;
  }

  (0, _createClass2.default)(EditModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          type = _this$props.type,
          onSave = _this$props.onSave,
          onClose = _this$props.onClose,
          onClick = _this$props.onClick,
          error = _this$props.error;
      var newName = this.state.newName;
      return (0, _preact.h)(_Modal.Modal, {
        isOpen: true,
        size: "medium"
      }, (0, _preact.h)(_Modal.ModalHeader, {
        title: type ? "Edit event type '".concat(type, "'") : 'New event type',
        onClose: onClose
      }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)(_InputGroup.default, {
        title: "Type name",
        value: newName,
        onChange: function onChange(e) {
          return _this2.setState({
            newName: e.target.value
          });
        },
        onClick: onClick,
        error: error
      })), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_buttonControl.default, {
        title: "Save changes",
        variant: "save",
        newStyle: true,
        onClick: function onClick() {
          return onSave(newName);
        },
        "data-track-type": "click",
        "data-element-name": "Save changes button"
      }), (0, _preact.h)(_buttonControl.default, {
        newStyle: true,
        title: "Cancel",
        onClick: onClose,
        "data-track-type": "click",
        "data-element-name": "Cancel button"
      })));
    }
  }]);
  return EditModal;
}(_preact.Component);

exports.EditModal = EditModal;
var _default = EditModal;
exports.default = _default;